import { Check, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

const POINTS = [
    "You are married and feel emotionally disconnected.",
    "You are a working woman balancing many responsibilities.",
    "You feel like you are always adjusting.",
    "You want more peace and connection at home.",
    "You want to understand your relationship patterns.",
    "You don't want another complicated relationship course.",
    "You want something simple you can start today.",
];

export const WhoFor = () => (
    <section className="relative bg-cream py-16 sm:py-24" data-testid="who-for-section">
        <div className="mx-auto grid max-w-5xl grid-cols-1 gap-12 px-5 sm:px-8 lg:grid-cols-12 lg:gap-16">
            <div className="lg:col-span-5">
                <Reveal>
                    <h2 className="font-serif text-2xl font-medium leading-snug text-plum sm:text-3xl lg:text-4xl">
                        This Guide Is <em className="italic text-burgundy">For You</em> If&hellip;
                    </h2>
                    <a
                        onClick={(e) => {
                            e.preventDefault();
                            window.dispatchEvent(new CustomEvent("open-checkout", { detail: { source: "who-for-inline-cta" } }));
                        }}
                        className="mt-6 inline-flex items-center gap-2 font-sans text-sm font-bold uppercase tracking-[0.14em] text-burgundy underline decoration-gold decoration-2 underline-offset-4 transition-colors hover:text-plum"
                        data-testid="who-for-inline-cta"
                    >
                        Get the guide &mdash; ₹49
                        <ArrowRight className="h-4 w-4" />
                    </a>
                </Reveal>
            </div>

            <Reveal delay={0.12} className="lg:col-span-7">
                <ul
                    className="divide-y divide-blushline rounded-2xl border border-blushline bg-white shadow-sm"
                    data-testid="who-for-list"
                >
                    {POINTS.map((point) => (
                        <li key={point} className="flex items-start gap-4 px-6 py-4.5 sm:px-8" style={{ paddingTop: "1.1rem", paddingBottom: "1.1rem" }}>
                            <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-blush">
                                <Check className="h-3.5 w-3.5 text-gold" strokeWidth={3} />
                            </span>
                            <span className="text-[0.98rem] leading-relaxed text-ink sm:text-lg">{point}</span>
                        </li>
                    ))}
                </ul>
            </Reveal>
        </div>
    </section>
);

export default WhoFor;
